import { render, staticRenderFns } from "./GD.vue?vue&type=template&id=cb70841a&scoped=true&"
import script from "./GD.vue?vue&type=script&lang=js&"
export * from "./GD.vue?vue&type=script&lang=js&"
import style0 from "./GD.vue?vue&type=style&index=0&id=cb70841a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb70841a",
  null
  
)

export default component.exports